import { propClassName } from '@/styles/Factbox';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { withNonHTMLChildren, withSafeInnerHTML } from 'lib/utils';
import { cn } from 'lib/utils/cn';

export interface FactboxHeadlineProps extends ComponentProps<'h2'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
}

export const FactboxHeadlineComponent: Component<FactboxHeadlineProps> = ({
  className,
  variant,
  colors,
  size,
  children,
  ...props
}) => {
  const variantClassName = propClassName('headline_variant', variant, 'default');
  const sizeClassName = propClassName('headline_size', size, 'default');
  const colorsClassName = propClassName('headline_colors', colors, 'primary');

  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  return (
    <h2 className={componentClassName} {...withSafeInnerHTML(children)} {...props}>
      {withNonHTMLChildren(children)}
    </h2>
  );
};
